module.exports = __webpack_public_path__ + "build/desktop/img/operator.fa0883c5c92646d6999471e5833b96b3.svg";